export var Apps;
(function (Apps) {
    Apps["Dataverse"] = "Dataverse";
    Apps["Playground"] = "Playground";
    Apps["MigrateOldFolders"] = "MigrateOldFolders";
})(Apps || (Apps = {}));
export var ModelNames;
(function (ModelNames) {
    ModelNames["indexFolders"] = "indexFolders";
    ModelNames["contentFolders"] = "contentFolders";
    ModelNames["indexFiles"] = "indexFiles";
})(ModelNames || (ModelNames = {}));
